export default __webpack_public_path__ + "static/favicon-d632da9177e484461fa09c7e94463c33.png";